export const clientsColumns = [
  { id: 'estado', label: 'Estado', type: 'select', sortable: true, required: true, options: [
    { value: 'Activo', label: 'Activo' },
    { value: 'Inactivo', label: 'Inactivo' },
  ] },
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'nit', label: 'NIT', type: 'text', sortable: true, required: true },
  { id: 'direccion', label: 'Dirección', type: 'text', sortable: true, required: true },
  { id: 'telefono', label: 'Teléfono', type: 'text', sortable: true, required: true },
  { id: 'tipoCobro', label: 'Tipo de Cobro', type: 'select', sortable: true, required: true, options: [
    { value: 'kilos', label: 'Por Kilos' },
    { value: 'cantidades', label: 'Por Cantidades' },
  ] },
  { 
    id: 'lavanderia', 
    label: 'Centro de Lavado', 
    type: 'asyncSelect', 
    sortable: true, 
    required: true, 
    fetchOptions: async () => {
      try {
        const { fetchLaundries } = await import('@/pages/parametrizacion/laundries/Services/laundries.services');
        const response = await fetchLaundries({ limit: 100, offset: 1, query: { estado: 'Activo' } });
        
        if (response && response.data) {
          return response.data.map(laundry => ({
            value: { 
              id: laundry._id,
              nombre: laundry.nombre 
            },
            label: laundry.nombre
          }));
        }
        return [];
      } catch (error) {
        console.error('Error cargando centros de lavado:', error);
        return [];
      }
    }
  },
  { id: 'habitacionesTotales', label: 'N° Habitaciones', type: 'number', sortable: true, required: false },
  { id: 'asesor', label: 'Asesor', type: 'text', sortable: true, required: false },
  { id: 'contacto', label: 'Contacto', type: 'text', sortable: true, required: false },
  {
    id: 'actions',
    label: 'Acciones',
    key: 'actions',
    actions: [
      {
        key: 'assignGarments',
        label: 'Asignar Prendas',
        icon: 'Shirt',
        tooltip: 'Asignar Prendas',
        className: 'text-blue-600 hover:text-blue-700',
      },
      {
        key: 'garmentPrices',
        label: 'Precios por Prenda',
        icon: 'DollarSign',
        tooltip: 'Precios por Prenda',
        className: 'text-green-600 hover:text-green-700',
      },
      {
        key: 'attachments',
        label: 'Adjuntos',
        icon: 'FileText',
        tooltip: 'Ver adjuntos',
        className: 'text-purple-600 hover:text-purple-700',
      },
      {
        key: 'edit',
        label: 'Editar',
        icon: 'Edit',
        tooltip: 'Editar',
        className: 'text-green-600 hover:text-green-700',
      },
      {
        key: 'delete',
        label: 'Eliminar',
        icon: 'Trash',
        tooltip: 'Eliminar',
        className: 'text-red-600 hover:text-red-700',
      },
    ],
  },
];

export const columnsExcel = clientsColumns.map(col => {
  if (col.id === 'lavanderia') {
    return { key: 'lavanderia.nombre', header: col.label };
  }
  return { key: col.id, header: col.label };
});
